export default function OutputInspector() {
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50/80 p-4 dark:border-white/10 dark:bg-slate-950/60">
      <div className="text-sm font-semibold text-slate-950 dark:text-white">
        Output action
      </div>

      <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-400">
        Deze stap gebruikt de ingestelde outputvelden en output preview.
      </p>
    </div>
  );
}